export default "__VITE_ASSET__670d4c47__"